export default __webpack_public_path__ + "static/media/exterior5.3b46d0e1.webp";